// extracted by mini-css-extract-plugin
module.exports = {"o-modal":"Modal_o-modal__f23mK","o-modal__container":"Modal_o-modal__container__3Ikao","o-modal__content":"Modal_o-modal__content__2rVtS"};